import React, { useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

// components
import {
  Button,
  StyledText,
  Span,
  TextInput,
  CurveHolder,
} from "../../components/common/basic";

// assest
// import loginheader from "../../../../public/assets/images/dev/loginheader.jpg";
import { Curve } from "../../components/svgs";

// hooks
import { useAuth } from "../../hooks/";

const ProvideNumber = () => {
  const {
    sendOTP,
    phoneNumber,
    setPhoneNumber,
    loginNumberError,
    loginLoading,
  } = useAuth();

  useEffect(() => {}, []);

  return (
    <MainHolder>
      {/* <Image src={loginheader} /> */}
      <CurveHolder>
        <Curve />
      </CurveHolder>
      <InputSection>
        <StyledText height={35} margin={0} fontFamily={600} size={24}>
          Welcome
        </StyledText>
        <StyledText height={24} size={14} fontFamily={300} margin={0}>
          <Span height={24} size={16} margin={0} fontFamily={700}>
            {"Yo! "}
          </Span>
          Welcome to MTN Pulse.
        </StyledText>
        <StyledText size={14} fontFamily={300} height={24} margin={0}>
          Please enter your phone number!
        </StyledText>
        <TextInput
          hasError={loginNumberError}
          placeholder={"Phone number"}
          hasIcon={true}
          marginTop={20}
          cb={(value) => {
            const number = value.replace(/[^0-9.]/g, "");

            setPhoneNumber(number);
          }}
        />
        {loginNumberError && (
          <StyledText margin={0} align={"center"} size={11} color={"#EE2737"}>
            Non MTN/Postpaid numbers not allowed.
          </StyledText>
        )}
        <ButtonHolder>
          <StyledText height={16} align={"center"} size={12} fontFamily={300}>
            By clicking continue, you agree to our
            <Link style={{ textDecoration: "none" }} to="/privacy">
              <Span size={12} fontFamily={300} color={"#e31c79"}>
                {" privacy policy"}
              </Span>
            </Link>
            .
          </StyledText>
          <Button
            disabled={loginLoading}
            margin={10}
            onClick={() => {
              if (!loginLoading) sendOTP(phoneNumber);
            }}
          >
            <StyledText color={"white"}>
              {loginLoading ? "Loading..." : "Continue"}
            </StyledText>
          </Button>
        </ButtonHolder>
      </InputSection>
    </MainHolder>
  );
};

const MainHolder = styled.div`
  display: grid;
  align-content: space-between;
  grid-template-rows: auto auto 1fr;
  overflow: hidden;
  height: 700px;
  @media screen and (max-width: 480px) {
    border-radius: 0px;
    padding-bottom: 5px;
    height: 100vh;
  }
`;

const Image = styled.img`
  height: 300px;
  width: 100%;
`;

const InputSection = styled.div`
  display: grid;
  grid-template-rows: auto auto auto auto 1fr;
  padding: 15px;
  margin-top: -20px;
  background-color: white;
`;

const ButtonHolder = styled.div`
  display: grid;
  align-content: center;
`;

export default ProvideNumber;
